import type {
  StoreCardItemPromoData,
  StoreCardItemPromoSource,
  StoreCardItemPromoType,
} from '@presentation/components';
import { useMemo } from 'react';
import { shuffle } from 'lodash/fp';
import { useTipawStore } from './useTipawStore';

export const useGetStorePromos = (source: StoreCardItemPromoSource) => {
  const { onPromoCardClick } = useTipawStore();

  const allPromoTypes: StoreCardItemPromoType[] = useMemo(
    () => ['digestion', 'itching', 'stress', 'mobility', 'growth'],
    [],
  );
  const listingPromoTypes: StoreCardItemPromoType[] = useMemo(
    () => ['digestion', 'itching', 'stress', 'mobility'],
    [],
  );

  const listingPromoItems = useMemo((): StoreCardItemPromoData[] => {
    return shuffle(listingPromoTypes).map((type) => {
      return {
        type,
        onClick: () => onPromoCardClick(type, source),
      };
    });
  }, [onPromoCardClick, listingPromoTypes, source]);

  const allPromoItems = useMemo((): StoreCardItemPromoData[] => {
    return allPromoTypes.map((type) => {
      return {
        type,
        onClick: () => onPromoCardClick(type, source),
      };
    });
  }, [onPromoCardClick, allPromoTypes, source]);

  return { listingPromoItems, allPromoItems };
};
